import React from "react";
import { GoBack } from "../../../components/Layout/GoBack";
import { BottomNav } from "../../../components/Nav/BottomNav";

const Plandetails = () => {
  return (
    <div>
      <div className="container px-4 pt-8 max-w-sm mx-auto relative  pb-24">
        <GoBack />

        <div className="mt-5">
          <img
            className="rounded-lg"
            src="/img/new/background/warehouse.jpeg"
          />
        </div>
        <h2 className="font-body font-bold text-xl mt-3">♻️ PROLOGIS ♻️</h2>

        <div className="mt-4 space-y-3">
          <div className="bg-gray-50 rounded-lg p-3">
            <h3 className="font-body font-bold text-base">🔰 BEGINNERS 🔰</h3>
            <p className="text-sm font-body text-textGray">20% daily profits</p>
            <p className="text-sm font-body text-textGray">
              Minimum = $30 | Maximum = $499
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3">
            <h3 className="font-body font-bold text-base">🔰 EXPERIENCED 🔰</h3>
            <p className="text-sm font-body text-textGray">30% daily profits</p>
            <p className="text-sm font-body text-textGray">
              Minimum = $500 | Maximum = $3,999
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3">
            <h3 className="font-body font-bold text-base">🔰 STANDARD 🔰</h3>
            <p className="text-sm font-body text-textGray">50% daily profits</p>
            <p className="text-sm font-body text-textGray">
              Minimum = $4,000 | Maximum = $5,999
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3">
            <h3 className="font-body font-bold text-base">🔰 PRO 🔰</h3>
            <p className="text-sm font-body text-textGray">80% daily profits</p>
            <p className="text-sm font-body text-textGray">
              Minimum = $6,000 | Maximum = UNLIMITED
            </p>
          </div>
        </div>

        <div className="mt-4">
          <h2 className="font-body font-bold text-base mb-2">
            FIRST DEPOSIT BONUS
          </h2>
          <p className="text-sm font-body text-textGray">
            ➡️ Deposit $30 and get $6 reward
          </p>
          <p className="text-sm font-body text-textGray">
            ➡️ Deposit $50 and get $10 reward
          </p>
          <p className="text-sm font-body text-textGray">
            ➡️ Deposit $100 and get $20 reward
          </p>
          <p className="text-sm font-body text-textGray">
            ➡️ Deposit $200 and get $40 reward
          </p>
        </div>

        <div className="mt-4">
          <h2 className="font-body font-bold text-base mb-2">
            REFERRAL LEVELS
          </h2>
          <p className="text-sm font-body text-textGray">®️ First plan (20%)</p>
          <p className="text-sm font-body text-textGray">
            ®️ Second plan (30%)
          </p>
          <p className="text-sm font-body text-textGray">®️ Third plan (50%)</p>
          <p className="text-sm font-body text-textGray">
            ®️ Fourth plan (80%)
          </p>
        </div>

        <div className="mt-4 space-y-1">
          <h2 className="font-body font-bold text-base mb-2">BENEFITS</h2>
          <p className="text-sm font-body text-textGray">
            ✅ 10 USDT REGISTRATION BONUS
          </p>
          <p className="text-sm font-body text-textGray">✅ DEPOSIT BONUS</p>
          <p className="text-sm font-body text-textGray">
            ✅ INSTANT WITHDRAW (5–10 mins)
          </p>
          <p className="text-sm font-body text-textGray">✅ NO WITHDRAW FEE</p>
          <p className="text-sm font-body text-textGray">✅ NO DEPOSIT FEE</p>
          <p className="text-sm font-body text-textGray">✅ TEAM COMMISSIONS</p>
          <p className="text-sm font-body text-textGray">
            ✅ TEAM LEADER BONUS
          </p>
          <p className="text-sm font-body text-textGray">✅ WEEKLY SALARY</p>
          <p className="text-sm font-body text-textGray">
            ✅ LIFE TIME ASSURED
          </p>
          <p className="text-sm font-body text-textGray">
            ✅ 24/7 ACTIVE CUSTOMER SERVICE
          </p>
          <p className="text-sm font-body text-textGray">
            ✅ DAILY EARNINGS AND WITHDRAWAL
          </p>
          <p className="text-sm font-body text-textGray">✅ FREE GIFT</p>
          <p className="text-sm font-body text-textGray">
            ✅ FREE VISA TO ANY COUNTRY OF YOUR CHOICE AS A TEAM LEADER
          </p>
        </div>
      </div>
      <div className=" max-w-sm mx-auto w-full ">
        <BottomNav />
      </div>
    </div>
  );
};

export default Plandetails;
